import * as types from '../actions/preferences/types';


const INITIAL_STATE = {};

export default function preferencesReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.PUBLIC_PREFERENCES:

      return action.payload;

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/preferencesReducer.js